export default __webpack_public_path__ + "static/banner-lg-57b18a09745068c8ceadaa270d0de709.png";